import { Checkbox } from '@mantine/core';

export interface MobileFilterCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const EmployedsMobileFilterCheckbox: React.FC<MobileFilterCheckboxProps> = ({
  checked,
  onChange,
  disabled,
}) => {
  return (
    <Checkbox
      color='#002CFB'
      size='24px'
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      label={null}
      disabled={disabled}
      styles={{
        label: {
          fontSize: '16px',
          lineHeight: '22px',
          color: '#121922',
          cursor: 'pointer',
          maxWidth: '300px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        inner: {
          height: '22px',
          display: 'flex',
          alignItems: 'center',
        },
        input: {
          border: checked ? '2px solid #002CFB' : '2px solid rgba(173, 191, 223, 0.40)',
          cursor: 'pointer',
        },
      }}
    />
  );
};
